var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProposal(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 15,
    viewBox: "0 0 21 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "navIcon",
    fill: "currentColor",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    d: "M7.888.232A.836.836 0 0 1 8.95.155l.092.077L19.07 9.947a.773.773 0 0 1 .073 1.037l-.073.081L15.207 15H9.205L1.548 7.492a.773.773 0 0 1-.073-1.037l.073-.08L7.888.231zm.577.832l-6.059 5.87L9.613 14h5.174l3.427-3.49-9.749-9.446z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 21,
    height: 1,
    y: 14,
    rx: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    d: "M9.978 9.879l8.59 1.695.372-.388a.795.795 0 0 0 0-1.13L9.039.234a.81.81 0 0 0-1.14 0L7.541.59l1.65 8.5a1 1 0 0 0 .787.79z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProposal);
export default __webpack_public_path__ + "static/media/proposal.79573573.svg";
export { ForwardRef as ReactComponent };